import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["accept", "disabled", "multiple"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 3v12" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m17 8-5-5-5 5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Перетащите или нажмите", -1)
const _hoisted_4 = { class: "trigger__formats" }
const _hoisted_5 = {
  key: 0,
  class: "bs-file-zone__preview"
}
const _hoisted_6 = { class: "item__content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" })
], -1)
const _hoisted_8 = { class: "content__container" }
const _hoisted_9 = { class: "container__name" }
const _hoisted_10 = { class: "container__size" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", { d: "M18 6 6 18" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "preview__item"
}
const _hoisted_16 = { class: "item__content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" })
], -1)
const _hoisted_18 = { class: "content__container" }
const _hoisted_19 = { class: "container__name" }
const _hoisted_20 = { class: "container__size" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", { d: "M18 6 6 18" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12" }, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-file-zone", { 'bs-file-zone--disabled': _ctx.disabled, 'bs-file-zone--invalid': _ctx.invalid }])
  }, [
    _createElementVNode("label", {
      class: "bs-file-zone__trigger",
      onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
      onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
    }, [
      _createElementVNode("input", {
        type: "file",
        hidden: "",
        accept: _ctx.accept,
        disabled: _ctx.disabled,
        multiple: _ctx.multiple,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
      }, null, 40, _hoisted_1),
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.acceptableFormats), 1)
    ], 32),
    (_ctx.isRenderingPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.multiple && Array.isArray(_ctx.modelValue))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.modelValue, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "preview__item",
                  key: item.name
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatFileSize(item.size)), 1)
                    ])
                  ]),
                  (_openBlock(), _createElementBlock("svg", {
                    class: "item__delete",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    onClick: ($event: any) => (_ctx.onDelete(i))
                  }, _hoisted_14, 8, _hoisted_11))
                ]))
              }), 128))
            : (_ctx.modelValue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString((_ctx.modelValue as File).name), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.formatFileSize((_ctx.modelValue as File).size)), 1)
                    ])
                  ]),
                  (_openBlock(), _createElementBlock("svg", {
                    class: "item__delete",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDelete(undefined)))
                  }, _hoisted_23))
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}